/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconKeyboardArrowUpFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconKeyboardArrowUpFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconKeyboardArrowUpFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconKeyboardArrowUpFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1jJQW9': alignSelf,'--mt-2-Z1jJQW9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1jJQW9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1jJQW9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1jJQW9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1jJQW9': opacity,'--w-10-Z1jJQW9': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1jJQW9': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1jJQW9': isAnimated ? animation : "none",'--sd-8-Z1jJQW9': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1jJQW9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconKeyboardArrowUpFilled.SvgPath"
  data-view-path={viewPath}
 d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
 style={{'--f-12-Z1jJQW9': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}